export default __webpack_public_path__ + "static/media/004-lifebuoy.40d0e264.png";